import weeklyReport from "@/pages/report/weeklyReport.vue";
import reportList from "@/pages/report/reportList.vue";
import adminReport from "@/pages/report/adminReport.vue";
import reportSummary from "@/pages/report/reportSummary.vue";
import exSummary from "@/pages/report/exSummary.vue";
import {PathName} from "@/constant/routeData";

export default [
  // 创建周报
  {
    path: '/weeklyReport',
    name: PathName.WeeklyReport,
    component: weeklyReport,
  },
  // 周报列表
  {
    path: '/reportList',
    name: PathName.ReportList,
    component: reportList,
  },
  // 全量周报
  {
    path: '/adminReport',
    name: PathName.AdminReport,
    component: adminReport,
  },
  // 周报summary
  {
    path: '/reportSummary',
    name: PathName.ReportSummary,
    component: reportSummary,
  },
  {
    path: '/exSummary',
    name: PathName.ExSummary,
    component: exSummary,
  }
]
